import React from "react";
import { Slider } from "antd";
import BaseListPage from "../../base/BaseListPage";

export default class AgeFilter extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  // componentDidUpdate(prevProps, prevState) {
  //   // console.log("")
  // }

  onSliderChange = (value) => {
    const { field } = this.props;

    let where = {};
    if (value && value.length === 2) {
      where = {
        [field]: {
          $gte: value[0],
          $lte: value[1],
        },
      };
    }

    try {
      this.props.onFilter(where);
    } catch (error) {
      console.error("Error applying filter: ", error);
    }
  };

  render() {
    const marks = {
      11: "Age From",
      89: "Age To",
    };

    return (
      <>
        <Slider
          range
          defaultValue={[0, 100]}
          onChange={this.onSliderChange}
          marks={marks}
        />
        <style jsx>{`
          .ant-slider-rail {
            background-color: #d9d9d9 !important;
          }
          .ant-slider-track {
            background-color: #29457c !important;
          }
          .ant-slider-handle {
            border-color: #29457c !important;
            background-color: #fff !important;
          }
        `}</style>
      </>
    );
  }
}
